import { NumberSelectorField, NumberSelectorFieldProps } from '@/components/common/field/NumberSelectorField';
import React, { FC, ReactElement } from 'react';

type Props = Omit<NumberSelectorFieldProps, 'name'>;

export const CrosswordCountSelectorField: FC<Props> = (props: Props): ReactElement => {
  const { minValue, maxValue, helperText, ...other } = props;

  return (
    <NumberSelectorField
      name={'crosswordCount'}
      minValue={minValue}
      maxValue={maxValue}
      label={'Количество бланков кроссвордов'}
      withLabel={true}
      isNotAbsoluteHelperText={true}
      helperText={helperText ? helperText : `Не более ${maxValue} бланков`}
      {...other}
    />
  );
};
